module.exports = __webpack_public_path__ + "static/media/nav-icon-sourcing.610c57ea.svg";